import { acChargerTypes } from '../acReduxExports'

const acChargersInitialState: AcChargerState = {
  selectedNav: 'info_graphics',
  chargerListRequestHash: null,
  chargers: null,
  chargersFilterHash:null,
  chargerCount: 0,
  chargerTableLoader: false,
  individualChargerDetail: null,
  individualChargerDetailLoader: false,
  lastRefreshTime: null,
  chargerDetail: null,
  chargerListTableProps: {
    view: 'list',
    pageSize: 15,
    pageNumber: 1,
    order: 'ascending',
    sortBy: 'alarmStatus',
    searchTerm: ''
  },
  chargerStatusMasterInfo:null,
  chargerStatusSystemInfo: null,
  chargerStatusMasterInfoAltered: null,
  chargerMasterInfo:null,
  chargerSystemInfo:  null,
  chargerSettingsMasterInfo: null,
  chargerSettingsSystemInfo: null,
  allowedCommandsForRoleReferenceData: null,
  chargerConnectorStatus: null,
  chargerNetwork: null,
  chargerHistoryGraphData: null,
  chargerHistoryGraphFilterHashes: [],
  chargerHistoryStartDate: null,
  chargerHistoryEndDate: null,
  chargerConnectorStatusLogs: null,
  chargerParametersTableLoader:false,
  chargerParameters:null,
  chargerParametersCount:0,
  chargerParametersDevices:null,
  chargerParametersDevicesCount:0,
  chargerParametersDevicesTableLoader:false,
  parameterDevicesStatusCount:null,
  parametersDetailLoader: false,
  parametersSettingsSystemInfo:null,
  chargerParametersDevicesListTableProps: {
    view: 'list',
    pageSize: 15,
    pageNumber: 1,
    order: 'descending',
    sortBy: '',
    searchTerm: ''
  },
  chargerParametersSettingsMasterInfo:  null,
  addParameterRefChargers:  null,
  addParameterRefChargingStations: null,
    chargerParametersListTableProps: {
    view: 'list',
    pageSize: 15,
    pageNumber: 1,
    order: 'descending',
    sortBy: 'createdOn',
    searchTerm: ''
  },
  individualParameterDetail: null,
  addParametersDetailsList: null,
  addParametersDetailsListLoader: false,
  chargerUpdateCommands: null,
  chargerUpdateCommandsCount:null,
    chargerUpdateCommandsListTableProps: {
    view: 'list',
    pageSize: 15,
    pageNumber: 1,
    order: 'descending',
    sortBy: '',
    searchTerm: ''
  },
    chargerUpdateCommandDevices:  null,
    chargerUpdateCommandDevicesCount: 0,
    updateCommandDevicesStatusCount: null,
      chargerUpdateCommandDevicesListTableProps: {
    view: 'list',
    pageSize: 15,
    pageNumber: 1,
    order: 'descending',
    sortBy: '',
    searchTerm: ''
  },
  chargerFiltersAppliedFromRedirection: false,
  chargerHistoryUptime: null,
  acSpuriousChargers: null,
  acSpuriousChargersCount: 0,
  acSpuriousChargersListTableProps: {
    view: 'list',
    pageSize: 15,
    pageNumber: 1,
    order: 'descending',
    sortBy: '',
    searchTerm: ''
  },
  acUptimeReportList: null,
  acUptimeReportListCount: 0,
  acUptimeChargerListTableProps: {
    view: 'list',
    pageSize: 15,
    pageNumber: 1,
    order: 'descending',
    sortBy: '',
    searchTerm: ''
  },
  activeCertificateRefreshChargerId: null,
}

const chargersReducer = (state: AcChargerState = acChargersInitialState, action: AcChargerAction): AcChargerState => {
  switch (action.type) {
    case acChargerTypes.AC_SET_CHARGER_LIST_REQUEST_HASH:
      return {
        ...state,
        chargerListRequestHash: action.chargerListRequestHash,
        chargersFilterHash: action.chargersFilterHash
      }
    case acChargerTypes.SET_AC_ACTIVE_CERTIFICATE_REFRESH_CHARGER_ID:
      return {
        ...state,
        activeCertificateRefreshChargerId: action.activeCertificateRefreshChargerId,
      }
    case acChargerTypes.UPDATE_AC_CHARGER_ACTIVE_CERTIFICATE:
      return {
        ...state,
        chargers: state.chargers?.map((charger) =>
          charger?.id === action.chargerId ? { ...charger, activeCertificate: action.activeCertificate } : charger
        ) ?? null,
      }
    case acChargerTypes.AC_FETCH_CHARGERS_DATA:
      return {
        ...state,
        chargers: action.chargers,
        chargerCount: action.chargerCount,
      }
    case acChargerTypes.FETCH_INDIVIDUAL_AC_CHARGER_DETAIL_DATA:
          return {
            ...state,
            individualChargerDetail: action.individualChargerDetail,
            
          }
    case acChargerTypes.SET_AC_CHARGER_LIST_TABLE_PROPS:
          return {
            ...state,
            chargerListTableProps: action.chargerListTableProps
          }
    case acChargerTypes.FETCH_AC_CHARGER_STATUS_MASTER_INFO_DATA:
          return {
            ...state,
            chargerStatusMasterInfo: action.chargerStatusMasterInfo
          }
    case acChargerTypes.FETCH_AC_CHARGER_STATUS_SYSTEM_INFO_DATA:
          return {
            ...state,
            chargerStatusSystemInfo: action.chargerStatusSystemInfo
          }
    case acChargerTypes.SET_ALTERED_MASTER_DATA_FOR_AC_CHARGER_STATUS:
          return {
            ...state,
            chargerStatusMasterInfoAltered: action.chargerStatusMasterInfoAltered,
    
          }
    case acChargerTypes.FETCH_AC_MASTER_INFO_DATA:
          return {
            ...state,
            chargerMasterInfo: action.chargerMasterInfo
          }
    case acChargerTypes.FETCH_AC_SYSTEM_INFO_DATA:
          return {
            ...state,
            chargerSystemInfo: action.chargerSystemInfo
          }
      case acChargerTypes.FETCH_AC_CHARGER_SETTINGS_MASTER_INFO_DATA:
          return {
            ...state,
            chargerSettingsMasterInfo: action.chargerSettingsMasterInfo
          }
      case acChargerTypes.FETCH_AC_CHARGER_SETTINGS_SYSTEM_INFO_DATA:
          return {
            ...state,
            chargerSettingsSystemInfo: action.chargerSettingsSystemInfo
          }
         case acChargerTypes.FETCH_ALLOWED_AC_COMMANDS_FOR_ROLE_REFERENCE_DATA:
          return {
            ...state,
            allowedCommandsForRoleReferenceData: action.allowedCommandsForRoleReferenceData
          }
          case acChargerTypes.FETCH_AC_CHARGER_CONNECTOR_STATUS_DATA:
              return {
                ...state,
                chargerConnectorStatus: action.chargerConnectorStatus,
                chargerNetwork: action.chargerNetwork,
                lastRefreshTime: action.lastRefreshTime
              }
      case acChargerTypes.FETCH_AC_CHARGER_GRAPH_DETAIL:
            return {
              ...state,
              chargerHistoryGraphData: action.chargerHistoryGraphData
            }
       case acChargerTypes.SET_AC_CHARGER_HISTORY_DATES:
          return {
            ...state,
            chargerHistoryStartDate: action.chargerHistoryStartDate,
            chargerHistoryEndDate: action.chargerHistoryEndDate,
          }
      case acChargerTypes.SET_AC_CHARGER_HISTORY_GRAPH_FILTER_HASHES:
                return {
                  ...state,
                  chargerHistoryGraphFilterHashes: action.chargerHistoryGraphFilterHashes
          
                }
          case acChargerTypes.FETCH_AC_CHARGER_STATUS_LOGS:
      return {
        ...state,
        chargerConnectorStatusLogs: action.chargerConnectorStatusLogs
      }

      case acChargerTypes.FETCH_AC_PARAMETERS_DATA:
            return {
              ...state,
              chargerParameters: action.chargerParameters,
              chargerParametersCount: action.chargerParametersCount
            }

      case acChargerTypes.SET_AC_PARAMETERS_LOADER:
          return {
            ...state,
            chargerParametersTableLoader: action.chargerParametersTableLoader,
          }


      case acChargerTypes.SET_AC_PARAMETERS_DEVICES_LOADER:
          return {
            ...state,
            chargerParametersDevicesTableLoader: action.chargerParametersDevicesTableLoader,
          }

      case acChargerTypes.FETCH_AC_PARAMETERS_DEVICES_DATA:
          return {
            ...state,
            chargerParametersDevices: action.chargerParametersDevices,
            chargerParametersDevicesCount: action.chargerParametersDevicesCount,
          }

      case acChargerTypes.FETCH_AC_PARAMETER_DEVICES_STATUS_COUNT:
          return {
            ...state,
            parameterDevicesStatusCount: action.parameterDevicesStatusCount,
          }
      case acChargerTypes.SET_AC_CHARGER_PARAMETERS_DEVICES_LIST_TABLE_PROPS:
          return {
            ...state,
            chargerParametersDevicesListTableProps: action.chargerParametersDevicesListTableProps
          }

    case acChargerTypes.CLEAR_AC_CHARGER_LIST_DATA:
          return {
            ...state,
            chargerListTableProps: {
              view: 'list',
              pageSize: state.chargerListTableProps?.pageSize || 15,
              pageNumber: state.chargerListTableProps?.pageNumber || 1,
              order: state.chargerListTableProps?.order || 'ascending',
              sortBy: state.chargerListTableProps?.sortBy || 'alarmStatus',
              searchTerm: ''
            },
          }

    case acChargerTypes.FETCH_AC_PARAMETERS_SETTINGS_SYSTEM_INFO_DATA:
          return {
            ...state,
            parametersSettingsSystemInfo: action.parametersSettingsSystemInfo
          }
    case acChargerTypes.FETCH_AC_CHARGER_PARAMETERS_SETTINGS_MASTER_INFO_DATA:
          return {
            ...state,
            chargerParametersSettingsMasterInfo: action.chargerParametersSettingsMasterInfo
          }
    case acChargerTypes.FETCH_ADD_AC_PARAMETERS_REF_CHARGERS:
          return {
            ...state,
            addParameterRefChargers: action.addParameterRefChargers,
          }
    case acChargerTypes.FETCH_AC_CHARGER_UPTIME:
          return {
            ...state,
            chargerHistoryUptime: action.chargerHistoryUptime
          }

    case acChargerTypes.FETCH_ADD_AC_PARAMETERS_REF_CHARGING_STATIONS:
          return {
            ...state,
            addParameterRefChargingStations: action.addParameterRefChargingStations,
          }
    case acChargerTypes.SET_AC_CHARGER_PARAMETERS_LIST_TABLE_PROPS:
          return {
            ...state,
            chargerParametersListTableProps: action.chargerParametersListTableProps
          }

    case acChargerTypes.CLEAR_AC_CHARGER_PARAMETER_LIST_DATA:
          return {
            ...state,
            // chargerParameters: null,
            // chargerParametersCount: 0,
            chargerParametersListTableProps: {
              view: 'list',
              pageSize: state.chargerParametersListTableProps?.pageSize || 15,
              pageNumber: state.chargerParametersListTableProps?.pageNumber || 1,
              order: state.chargerParametersListTableProps?.order || 'descending',
              sortBy: state.chargerParametersListTableProps?.sortBy || 'createdOn',
              searchTerm: ''
            },
          }
      case acChargerTypes.CLEAR_AC_CHARGER_PARAMETER_DEVICES_LIST_DATA:
         return {
           ...state,
           chargerParametersDevices: null,
           chargerParametersDevicesCount: 0,
           chargerParametersDevicesListTableProps: {
             view: 'list',
             pageSize: state.chargerParametersDevicesListTableProps?.pageSize || 15,
             pageNumber: state.chargerParametersDevicesListTableProps?.pageNumber || 1,
             order: 'ascending',
             sortBy: '',
             searchTerm: ''
           },
         }
      case acChargerTypes.CLEAR_AC_PARAMETER_DEVICES_STATUS_COUNT:
          return {
            ...state,
            parameterDevicesStatusCount: null
          }
        case acChargerTypes.FETCH_AC_INDIVIDUAL_PARAMETER_DETAIL_DATA:
          return {
            ...state,
            individualParameterDetail: action.individualParameterDetail,
            // lastRefreshTime: action.lastRefreshTime
          }
        case acChargerTypes.CLEAR_UPDATED_AC_PARAMETER_DETAIL_DATA:
            return {
              ...state,
              individualParameterDetail: null,
            }

        case acChargerTypes.FETCH_ADD_AC_PARAMETERS_DETAIL_LIST:
            return {
              ...state,
              addParametersDetailsList: action.addParametersDetailsList,
            }
        case acChargerTypes.CLEAR_AC_CHARGER_GRAPH_DETAIL:
              return {
                ...state,
                chargerHistoryGraphData: action.chargerHistoryGraphData
              }
        case acChargerTypes.FETCH_AC_UPDATE_COMMANDS_DATA:
                return {
                  ...state,
                  chargerUpdateCommands: action.chargerUpdateCommands,
                  chargerUpdateCommandsCount: action.chargerUpdateCommandsCount,
                }

        case acChargerTypes.SET_AC_CHARGER_UPDATE_COMMANDS_LIST_TABLE_PROPS: 
                return {
                  ...state,
                  chargerUpdateCommandsListTableProps: action.chargerUpdateCommandsListTableProps
                }
        case acChargerTypes.FETCH_UPDATE_AC_COMMANDS_DEVICES_DATA:
                      return {
                        ...state,
                        chargerUpdateCommandDevices: action.chargerUpdateCommandDevices,
                        chargerUpdateCommandDevicesCount: action.chargerUpdateCommandDevicesCount,
                      }

                 case acChargerTypes.FETCH_UPDATE_AC_COMMAND_DEVICES_STATUS_COUNT:
                      return {
                        ...state,
                        updateCommandDevicesStatusCount: action.updateCommandDevicesStatusCount
                      } 
                          case acChargerTypes.SET_AC_CHARGER_UPDATE_COMMANDS_DEVICES_LIST_TABLE_PROPS:
                            return {
                              ...state,
                              chargerUpdateCommandDevicesListTableProps: action.chargerUpdateCommandDevicesListTableProps
                            }
                                  case acChargerTypes.CLEAR_AC_CHARGER_UPDATE_COMMANDS_LIST_DATA:
                                    return {
                                      ...state,
                                      chargerUpdateCommandsListTableProps: {
                                        view: 'list',
                                        pageSize: state.chargerUpdateCommandsListTableProps?.pageSize || 15,
                                        pageNumber: state.chargerUpdateCommandsListTableProps?.pageNumber || 1,
                                        order: state.chargerUpdateCommandsListTableProps?.order || 'descending',
                                        sortBy: state.chargerUpdateCommandsListTableProps?.sortBy || 'createdOn',
                                        searchTerm: ''
                                      },
                                    }
                                case acChargerTypes.CLEAR_AC_CHARGER_UPDATE_COMMAND_DEVICES_LIST_DATA:
                                 return {
                                ...state,
                                chargerUpdateCommandDevices: null,
                                chargerUpdateCommandDevicesCount: 0,
                                chargerUpdateCommandDevicesListTableProps: {
                                  view: 'list',
                                  pageSize: state.chargerUpdateCommandDevicesListTableProps?.pageSize || 15,
                                  pageNumber: state.chargerUpdateCommandDevicesListTableProps?.pageNumber || 1,
                                  order: 'ascending',
                                  sortBy: '',
                                  searchTerm: ''
                                },
                              }
                              case acChargerTypes.CLEAR_AC_UPDATE_COMMAND_DEVICES_STATUS_COUNT:
                                return {
                                  ...state,
                                  updateCommandDevicesStatusCount: null
                                }

                                case acChargerTypes.SET_AC_FILTERS_APPLIED_FROM_REDIRECTION:
                                      return {
                                        ...state,
                                        chargerFiltersAppliedFromRedirection: action.chargerFiltersAppliedFromRedirection
                                      }
                                    case acChargerTypes.SET_AC_CHARGER_LOADER:
                                      return {
                                        ...state,
                                        chargerTableLoader: action.chargerTableLoader
                                      }
                                          case acChargerTypes.FETCH_AC_CHARGER_DETAIL_DATA:
                                            return {
                                              ...state,
                                              chargerDetail: action.chargerDetail,
                                            }

                                                case acChargerTypes.CLEAR_AC_CHARGER_DETAIL:
                                                  return {
                                                    ...state,
                                                    selectedNav: 'info_graphics',
                                                    individualChargerDetail: null,
                                                    chargerMasterInfo: null,
                                                    chargerSystemInfo: null,
                                                    chargerConnectorStatus: null,
                                                    chargerNetwork: null,
                                                    lastRefreshTime: null,
                                                    chargerHistoryGraphData: null,
                                                    chargerConnectorStatusLogs: null,
                                                    chargerStatusMasterInfo: null,
                                                    chargerStatusSystemInfo: null,
                                                    chargerSettingsMasterInfo: null,
                                                    chargerSettingsSystemInfo: null,
                                                    chargerStatusMasterInfoAltered: null,
                                                    chargerDetail: null,
                                                    chargerHistoryGraphFilterHashes: [],
                                                  }

    case acChargerTypes.FETCH_AC_SPURIOUS_CHARGERS_DATA:
      return {
        ...state,
        acSpuriousChargers: action.acSpuriousChargers,
        acSpuriousChargersCount: action.acSpuriousChargersCount,
      }
    case acChargerTypes.SET_AC_SPURIOUS_CHARGERS_LIST_TABLE_PROPS:
      return {
        ...state,
        acSpuriousChargersListTableProps: action.acSpuriousChargersListTableProps
      }
    case acChargerTypes.CLEAR_AC_SPURIOUS_CHARGERS_LIST_DATA:
      return {
        ...state,
        acSpuriousChargersListTableProps: {
          view: 'list',
          pageSize: state.acSpuriousChargersListTableProps?.pageSize || 15,
          pageNumber: state.acSpuriousChargersListTableProps?.pageNumber || 1,
          order: state.acSpuriousChargersListTableProps?.order || 'descending',
          sortBy: state.acSpuriousChargersListTableProps?.sortBy || 'createdAt',
          searchTerm: ''
        },
      }
    case acChargerTypes.FETCH_AC_UPTIME_REPORT_CHARGER_DATA:
      return {
        ...state,
        acUptimeReportList: action.acUptimeReportList,
        acUptimeReportListCount: action.acUptimeReportListCount,
      }
    case acChargerTypes.SET_AC_UPTIME_CHARGER_LIST_TABLE_PROPS:
      return {
        ...state,
        acUptimeChargerListTableProps: action.acUptimeChargerListTableProps,
      }
    default:
      return state
  }
}

export default chargersReducer